var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"icon":"mdi-sync","title":"Sync","loading":_vm.loading},on:{"click":_vm.sync}})
}
var staticRenderFns = []

export { render, staticRenderFns }